import { Box, useTheme } from '@mui/material';
import AiLogo from './AILogo';
import LogoText from './logo-text.partial';
import { memo } from 'react';

type Props = {
  textColor?: string;
  aiBackgroundColor?: string;
};

const RegistrationLogo = ({
  aiBackgroundColor = '#0066FF',
  textColor = '#070733',
}: Props) => {
  const theme = useTheme();

  return (
    // <a href="https://www.optionsai.com" target="_blank">
    <Box
      height={theme.spacing(3)}
      display="flex"
      flexDirection="row"
      alignItems="flex-start"
    >
      <Box mr="13.27px">
        <LogoText fill={textColor} />
      </Box>
      <AiLogo backgroundColor={aiBackgroundColor} />
    </Box>
    // </a>
  );
};

export default memo(RegistrationLogo);
